import {createSelector} from '@ngrx/store';
import {appClaimEntityAdapter as EntityAdapter, AppClaimState as EntityState} from "./app-claim.state";
import {AppClaim as Entity} from './app-claim.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.appClaim;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
    createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
    selectState,
    (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntity = createSelector(selectState, (state: EntityState) => state.currentEntity);

export const AppClaimSelectors = {
    selectAll,
    selectById,
    isLoading,
    hasErrors,
    findByCorrelationId,
    currentEntity
};
